module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IArs4c6QAAAIpQTFRFAAAAAAAAQEBAbW1tXV1dampqaWlpYWFhampqY2Nja2traGhoZGRkZmZmaGhoZWVlZ2dnaGhoZmZmZ2dnZmZmZmZmZmZmZmZmZmZmZ2dnZmZmZmZmZ2dnZ2dnZmZmZmZmZ2dnZmZmZ2dnZ2dnZ2dnZmZmZmZmZmZmZmZmZWVlZmZmZmZmZmZmZmZmK8/zoAAAAC10Uk5TAAEEBwsMERUYHx8gKS07P1JbX22Ch4qTmZ+io6mwtru9wMLHydLT2+Tl8PP+FC/9GQAAAG9JREFUGNNjYCAZMEtqSzChibHIq/CpyqCKsikrsDKwo4pyqMoyMzCginKrS0E4SKI8GuKMUCZCVFUMYRC7mgiEocONZLyQIoTW5UISFFRCFmSXxiLIq0WRICeqmdoCnAggKgcRFNbWRQBNflICHACC+wra025vhgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/open/leftbar_icon_home_n.png
// module id = z1H7
// module chunks = 1